import { useState } from 'react'
import styles from './Gallery.module.css'
import Fullscreen from './Fullscreen'

export type GalleryImageType = {
    src: string
    className?: string | undefined
}

interface galleryPropsInterface {
    images: GalleryImageType[]
}

export default function Gallery(props: galleryPropsInterface) {
    const { images } = props
    const [ showFullscreen, setShowFullscreen ] = useState(false)
    const [ imageIndex, setImageIndex ] = useState(0)

    return (
        <div className={ styles.galleryContainer }>
            {
                images.map((image, index) => {
                    let className = styles.imageContainer
                    if(image.className && image.className.length > 0) {
                        className += ' ' + image.className
                    }

                    return (
                        <div
                            key={ `gallery-image-${index}-${ image.src }` }
                            className={ className }
                            style={{
                                backgroundImage: `url(${ image.src })`
                            }}
                            onClick={() => {
                                setImageIndex(index)
                                setShowFullscreen(true)
                            }}
                        >
                        </div>
                    )
                })
            }

            <Fullscreen visible={ showFullscreen } onClose={() => setShowFullscreen(false) } images={ images } imageIndex={ imageIndex } />
        </div>
    );
}